import React from 'react';
import { Container } from '@mui/material';
import SaidaForm from '../components/saida/SaidaForm';

const SaidaNova: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <SaidaForm />
    </Container>
  );
};

export default SaidaNova;
